import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const teamsSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.TEAMS_SELECTOR}`,
        popover: {
            title: "Tournament Selector",
            description:
                "Switch the tournament to see how every team performed in a different competition — all KPI cards refresh instantly.",
            side: "bottom",
            align: "end",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAMS_SORT}`,
        popover: {
            title: "Sort Teams",
            description:
                "Reorder the cards by Total KPI, Average KPI, Average Player KPI, or Average Goalie KPI. " +
                "Click the active option again to flip the sort direction.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAMS_GRID}`,
        popover: {
            title: "Team Cards",
            description:
                "Each card shows the team's Total KPI, Average KPI, Average Player KPI, and Average Goalie KPI for the selected tournament. " +
                "The top-ranked team is highlighted with a gold star. " +
                "Click to have the app present data specifically for the given team.",
            side: "top",
            align: "center",
        },
    },
];
